// @core/api/endpoints/booking/list_my_bookings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListBookingsResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * List my bookings
 * Returns bookings where the current user is the customer. Customer-facing booking history.
 */
export async function ListMyBookings(
  params?: {
    cursor?: string | number | boolean;
    date_from?: string | number | boolean;
    date_to?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    sort?: string | number | boolean;
    status?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListBookingsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/bookings/my`;
  const requestOptions = options;
  return client.get<ListBookingsResponse>(requestPath, { ...requestOptions, params });
}
